import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { BalanceService } from 'src/app/services/api/balance.service';
import { ToastService } from 'src/app/services/toast.service';
import * as moment from 'moment';
import 'moment/locale/id';
import {
  LocaleConfig,
  DaterangepickerDirective,
} from 'ngx-daterangepicker-material';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Dayjs } from 'dayjs';
import { BalanceResponseType } from 'src/app/types/response/balance-response.type';
import { ResponseCustomType } from 'src/app/types/response/response.type';
import { balanceModel } from 'src/app/models/balance.model';
import { ComissionService } from 'src/app/services/api/comission.service';
import { LocaleConfigDate } from 'src/app/constants/date-config.const';

@Component({
  standalone: false,
  selector: 'app-detail-komisi',
  templateUrl: './detail-komisi.component.html',
  styleUrls: ['./detail-komisi.component.scss'],
})
export class DetailKomisiComponent {
  @Input() HistoryList: any[] = [];
  @Input() filterHistory: any = {
    start_date: moment().format('YYYY-MM-DD') + ' ' + '00:00:00',
    end_date: moment().format('YYYY-MM-DD') + ' ' + '23:59:59',
    transaction_type: 'withdrawal,order_commission',
    limit: 50,
    offset: 0,
    search: '',
  };
  keepCalendarOpeningWithRange: boolean;
  @Output() filterResult = new EventEmitter();
  destroy$ = new Subject();
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective!: DaterangepickerDirective;
  @ViewChild('checkBoxRef', { static: false }) checkBoxRef!: ElementRef;
  @Input() balance: balanceModel = {};
  form!: FormGroup;
  uncheck = false;
  uncheckList!: boolean;
  loading: boolean = true;

  selected: any = {
    startDate: moment(),
    endDate: moment(),
  };

  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
  };

  invalidDates: moment.Moment[] = [
    moment().add(2, 'days'),
    moment().add(3, 'days'),
    moment().add(5, 'days'),
  ];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some((d) => d.isSame(m, 'day'));
  };

  setlocale: LocaleConfig = LocaleConfigDate

  status: any = [
    {
      value: 'withdrawal',
      label: 'Commission Withdrawal',
      id: 'withdrawal',
      checked: false,
    },
    {
      value: 'order_commission',
      label: 'Order Commission',
      id: 'order_commission',
      checked: false,
    },
  ];

  selectedStatuses: string[] = [];
  resi: string = '';
  private searchSubject = new Subject<string>();
  $destroy = new Subject();

  constructor(
    private balanceService: BalanceService,
    private commisionService: ComissionService,
    private route: Router,
    private toastService: ToastService,
    public formatter: NgbDateParserFormatter
  ) {
    this.keepCalendarOpeningWithRange = true;
  }
  ngOnInit(): void {
    this.getHistory();
    this.getBalance();
    setTimeout(()=>{
      this.loading = false
    }, 1000)

    this.searchSubject.pipe(debounceTime(1000)).subscribe((value) => {
          this.filterHistory.search = value;
          this.filterResult.emit(this.filterHistory);
          this.getHistory();
        });
  }
  getBalance() {
    this.balanceService
      .balance()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: ResponseCustomType<BalanceResponseType>) => {
          this.balance = res.data;
        },
        (error) => {}
      );
  }
  back() {
    this.route.navigate(['finance/balance']);
  }

  onChangeSearch(value: any) {
    if (value.length >= 3 || value.length === 0) {
      this.searchSubject.next(value);
    }
  }

  getStatus(event: any, list: any) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    if (isChecked && !this.selectedStatuses.includes(list.value)) {
      this.selectedStatuses.push(list.value);
    } else if (!isChecked && this.selectedStatuses.includes(list.value)) {
      this.selectedStatuses = this.selectedStatuses.filter(
        (value) => value !== list.value
      );
    }

    if (this.selectedStatuses.length > 0) {
      this.filterHistory.transaction_type = this.selectedStatuses.join(',');
    } else {
      this.filterHistory.transaction_type = 'withdrawal,order_commission';
      this.selectedStatuses = [];
    }

    this.status = this.status.map((item: any) => {
      if (item.value === list.value) {
        return { ...item, checked: isChecked };
      }
      return item;
    });

    this.filterResult.emit(this.filterHistory);
    this.getHistory();
  }

  resetFilter() {
    this.filterHistory.start_date =
      moment().format('YYYY-MM-DD') + ' ' + '00:00:00';
    this.filterHistory.end_date =
      moment().format('YYYY-MM-DD') + ' ' + '23:59:59';
    (this.filterHistory.transaction_type = 'withdrawal,order_commission'),
      (this.selectedStatuses = []);

    this.filterResult.emit(this.filterHistory);
    this.getHistory();

    this.status.forEach((item: any) => {
      item.checked = false;
    });
  }
  openDatepicker() {
    this.pickerDirective.open();
  }
  onChangeDate(e: any) {
    const endDate: Dayjs = e.endDate;
    const startDate: Dayjs = e.startDate;

    this.filterHistory.start_date = startDate ?
      startDate.format('YYYY-MM-DD') + ' ' + '00:00:00' : this.selected.startDate.format('YYYY-MM-DD') + ' ' + '00:00:00';

    this.filterHistory.end_date = endDate ?
      endDate.format('YYYY-MM-DD') + ' ' + '23:59:59' : this.selected.endDate.format('YYYY-MM-DD') + ' ' + '23:59:59';

    this.filterResult.emit(this.filterHistory);
    this.getHistory();
  }

  salinResi(): void {
    const noresi = this.resi;
    navigator.clipboard
      .writeText(noresi)
      .then(() => {
        this.toastService.show(null, 'Receipt Number successfully copied', 'success', {
          classname: 'bg-success',
          delay: 3000,
        });
      })
      .catch((e) => console.log(e));
  }

  getHistory(): void {
    this.commisionService
      .commisionHistory(this.filterHistory)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.HistoryList = res.data;
        },
        () => {}
      );
  }
  transactionType(v: string) {
    if (v === 'order_commission') {
      return 'Order Completed';
    } else {
      return 'Commission Withdrawal';
    }
  }
  ngOnDestroy(): void {
    this.destroy$.unsubscribe();
  }
}
